module.exports = __webpack_public_path__ + "static/rapid-adb2db2049df40ffc4f799a4080ee101.png";